import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

/**
 * True when this page load came from the password-reset link in the email
 * (`#access_token=...&type=recovery`). Read before createClient, which consumes
 * the hash. supabase-js also emits PASSWORD_RECOVERY, but only once and right
 * after processing the URL; the embed mounts React later (it waits for the
 * Hostinger iframe), so its listener misses the event.
 */
export const openedFromRecoveryLink = /[#&]type=recovery(&|$)/.test(window.location.hash);

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
